/* eslint-disable */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { createPortal } from "react-dom";
import { toast } from "sonner";
import { Trash2, Pencil, Activity, Layers, Receipt, FileText, X, Download, MessageCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const $ = (v) => `$${Number(v || 0).toFixed(2)}`;
const fdate = (d) => (d ? new Date(d).toLocaleString("fr-FR") : "");
const inp = "bg-white border border-zinc-300 rounded-lg px-3 py-2 text-sm text-zinc-900 outline-none focus:border-amber-500";
const card = "bg-white border border-zinc-200 rounded-2xl p-5 shadow-sm";

const useUsers = () => {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    Promise.all([axios.get(`${API}/stockers`), axios.get(`${API}/network-marketers`)]).then(([a, b]) => {
      const s = Array.isArray(a.data) ? a.data : a.data.stockers || []; const n = Array.isArray(b.data) ? b.data : b.data.marketers || b.data.network_marketers || [];
      setUsers([...s.map((x) => ({ ...x, r: "Stocker" })), ...n.map((x) => ({ ...x, r: "NM" }))]);
    }).catch(() => {});
  }, []);
  return users;
};

const UserSearch = ({ onPick, testid }) => {
  const users = useUsers(); const [q, setQ] = useState("");
  const hits = q ? users.filter((u) => `${u.name} ${u.code}`.toLowerCase().includes(q.toLowerCase())).slice(0, 8) : [];
  return (
    <div className="relative">
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Tapez le nom ou le code…" className={`${inp} w-full`} data-testid={testid} />
      {hits.length > 0 && (
        <div className="absolute z-40 left-0 right-0 mt-1 bg-white border border-zinc-200 rounded-xl shadow-xl">
          {hits.map((u) => <button key={u.id} onClick={() => { onPick(u); setQ(""); }} className="w-full text-left px-3 py-2 hover:bg-amber-50 text-sm text-zinc-900" data-testid={`${testid}-hit-${u.code}`}>{u.name} <span className="text-zinc-500 text-xs">· {u.code} · {u.country} ({u.r})</span></button>)}
        </div>
      )}
    </div>
  );
};

// ===== 4. Sale corrections =====
export const SaleCorrections = () => {
  const [user, setUser] = useState(null); const [data, setData] = useState(null);
  const load = (u) => axios.get(`${API}/ceo/sales/${u.id}`).then((r) => setData(r.data));
  const act = async (sale, action) => {
    let body = { action };
    if (action === "edit") {
      const q = window.prompt(`Nouvelle quantité pour ${sale.vape_model || sale.model} (actuel ${sale.quantity_sold ?? sale.quantity}) :`, sale.quantity_sold ?? sale.quantity);
      if (q === null) return;
      const p = window.prompt("Prix unitaire ($) :", sale.price_per_unit ?? sale.price ?? 0);
      if (p === null) return;
      body = { action, quantity_sold: parseInt(q, 10), price_per_unit: parseFloat(p) };
    } else if (!window.confirm("Supprimer cette vente ? Le stock sera remis.")) return;
    const reason = window.prompt("Motif obligatoire de la correction :");
    if (!reason || !reason.trim()) return toast.error("Motif obligatoire");
    try { await axios.post(`${API}/ceo/sales/${user.id}/${sale.id}/correct`, { ...body, reason }); toast.success("Correction enregistrée"); load(user); }
    catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };
  return (
    <div className={card} data-testid="sale-corrections">
      <p className="text-zinc-900 font-black text-lg mb-1 flex items-center gap-2"><Pencil className="w-5 h-5 text-amber-600" />Correction des ventes</p>
      <p className="text-zinc-500 text-xs mb-3">Modifier ou supprimer une vente précise — motif et horodatage obligatoires.</p>
      <UserSearch onPick={(u) => { setUser(u); load(u); }} testid="sc-user-search" />
      {data && (
        <div className="mt-4">
          <p className="text-zinc-900 font-bold mb-2">{data.name} · {data.code}</p>
          <div className="space-y-1.5 max-h-80 overflow-y-auto">
            {data.sales.length === 0 && <p className="text-zinc-500 text-sm">Aucune vente dans le cycle actuel.</p>}
            {data.sales.map((s) => (
              <div key={s.id} className="flex items-center gap-3 bg-zinc-50 border border-zinc-200 rounded-xl px-3 py-2" data-testid={`sc-sale-${s.id}`}>
                <div className="flex-1 min-w-0"><p className="text-zinc-900 text-sm font-bold">{s.vape_model || s.model} × {s.quantity_sold ?? s.quantity} @ {$(s.price_per_unit ?? s.price)}</p><p className="text-zinc-500 text-[11px]">{fdate(s.recorded_at || s.date)}{s.corrected_at ? " · corrigée" : ""}</p></div>
                <button onClick={() => act(s, "edit")} className="text-xs font-bold bg-amber-400 text-black px-3 py-1.5 rounded-lg" data-testid={`sc-edit-${s.id}`}>Modifier</button>
                <button onClick={() => act(s, "delete")} className="text-xs font-bold bg-red-600 text-white px-3 py-1.5 rounded-lg" data-testid={`sc-del-${s.id}`}>Supprimer</button>
              </div>
            ))}
          </div>
          {data.corrections.length > 0 && (
            <div className="mt-4"><p className="text-zinc-500 text-[10px] font-black uppercase mb-1">Journal des corrections</p>
              {data.corrections.map((c) => <p key={c.id} className="text-xs text-zinc-700 border-t border-zinc-100 py-1">{fdate(c.created_at)} — {c.action === "delete" ? "Suppression" : "Modification"} {c.model} ({c.before.quantity_sold}{c.after ? ` → ${c.after.quantity_sold}` : " → 0"}) · Motif : {c.reason}</p>)}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

// ===== 14. Expenses =====
export const ExpensesPanel = () => {
  const [d, setD] = useState(null); const [f, setF] = useState({ name: "", amount: "", country: "" }); const [month, setMonth] = useState("");
  const load = (m) => axios.get(`${API}/ceo/expenses`, { params: m ? { month: m } : {} }).then((r) => { setD(r.data); setMonth(r.data.month); });
  useEffect(() => { load(); }, []);
  const add = async () => { try { await axios.post(`${API}/ceo/expenses`, f); setF({ name: "", amount: "", country: "" }); toast.success("Dépense enregistrée"); load(month); } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); } };
  const del = async (id) => { if (window.confirm("Supprimer cette dépense ?")) { await axios.delete(`${API}/ceo/expenses/${id}`); load(month); } };
  const total = (d?.monthly_totals || []).find((m) => m.month === month)?.total || 0;
  return (
    <div className={card} data-testid="expenses-panel">
      <p className="text-zinc-900 font-black text-lg mb-1 flex items-center gap-2"><Receipt className="w-5 h-5 text-amber-600" />Dépenses</p>
      <p className="text-zinc-500 text-xs mb-3">Suivi uniquement — non déduit du bénéfice net.</p>
      <div className="flex gap-2 flex-wrap mb-3">
        <input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Nom (envoi stock, stickers…)" className={`${inp} flex-1 min-w-[160px]`} data-testid="exp-name" />
        <input value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} type="number" placeholder="Montant $" className={`${inp} w-28`} data-testid="exp-amount" />
        <input value={f.country} onChange={(e) => setF({ ...f, country: e.target.value })} placeholder="Pays" className={`${inp} w-32`} data-testid="exp-country" />
        <button onClick={add} className="bg-black text-amber-400 font-black text-sm px-4 rounded-lg" data-testid="exp-add">Ajouter</button>
      </div>
      <div className="flex gap-2 flex-wrap mb-3">
        {(d?.monthly_totals || []).map((m) => <button key={m.month} onClick={() => load(m.month)} className={`text-xs font-bold px-3 py-1.5 rounded-lg ${m.month === month ? "bg-amber-400 text-black" : "bg-zinc-100 text-zinc-700"}`} data-testid={`exp-month-${m.month}`}>{m.month} · {$(m.total)}</button>)}
      </div>
      <p className="text-zinc-900 font-black mb-2" data-testid="exp-month-total">Total {month} : {$(total)}</p>
      {(d?.items || []).map((e) => (
        <div key={e.id} className="flex items-center gap-3 border-t border-zinc-100 py-1.5 text-sm" data-testid={`exp-item-${e.id}`}>
          <span className="flex-1 text-zinc-900">{e.name}</span><span className="text-zinc-500 text-xs">{e.country}</span><span className="font-black text-zinc-900">{$(e.amount)}</span>
          <button onClick={() => del(e.id)} className="text-red-500"><Trash2 className="w-4 h-4" /></button>
        </div>
      ))}
    </div>
  );
};

// ===== 7. Money entries (control payments) =====
export const PlatformIncome = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/ceo/platform-income`).then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <div className={card} data-testid="platform-income">
      <p className="text-zinc-900 font-black text-lg mb-2">💰 Entrées d'argent (paiements de contrôle)</p>
      <div className="flex gap-2 flex-wrap mb-3">
        <span className="bg-emerald-600 text-white font-black text-sm px-3 py-1.5 rounded-lg" data-testid="income-total">Total : {$(d.total)}</span>
        {d.monthly.map((m) => <span key={m.month} className="bg-zinc-100 text-zinc-800 text-xs font-bold px-3 py-1.5 rounded-lg">{m.month} · {$(m.total)}</span>)}
      </div>
      <div className="max-h-60 overflow-y-auto">
        {d.items.map((i) => <div key={i.id} className="flex gap-3 text-sm border-t border-zinc-100 py-1.5"><span className="flex-1 text-zinc-900">{i.user_name} <span className="text-zinc-500 text-xs">· {i.code}</span></span><span className="text-zinc-500 text-xs">{i.vapes} vape(s) · {fdate(i.created_at)}</span><span className="font-black text-emerald-700">{$(i.amount)}</span></div>)}
        {!d.items.length && <p className="text-zinc-500 text-sm">Aucun paiement de contrôle encore.</p>}
      </div>
    </div>
  );
};

// ===== 11-13. Investment lots =====
const LotReport = ({ r, onClose }) => (
  <div className="fixed inset-0 z-[130] bg-black/80 flex items-center justify-center p-4" onClick={onClose} data-testid="lot-report-modal">
    <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto p-6 text-zinc-900" onClick={(e) => e.stopPropagation()}>
      <div className="flex justify-between mb-3"><p className="font-black text-xl">Rapport — {r.lot_name} ({r.period})</p><button onClick={onClose}><X className="w-5 h-5" /></button></div>
      <div className="grid grid-cols-3 gap-2 mb-3">
        {[["Investi", $(r.invested)], ["Revenus réels", $(r.revenue)], ["Profit réel", $(r.real_profit)], ["Estimation", $(r.estimated_profit)], ["Écart vs estimation", $(r.vs_estimate)], ["Pas encore rentré", $(r.money_not_in_yet)]].map(([k, v]) => (
          <div key={k} className="bg-zinc-100 rounded-xl p-3"><p className="text-zinc-500 text-[10px] uppercase font-black">{k}</p><p className="font-black">{v}</p></div>))}
      </div>
      {r.beats_estimate && <p className="bg-emerald-600 text-white font-black rounded-lg px-3 py-2 mb-3">🎉 Profit réel supérieur à l'estimation de {$(r.vs_estimate)}</p>}
      <p className="font-black text-sm mb-1">Pas encore vendu ({r.not_sold_yet.length}) :</p>
      <p className="text-sm text-zinc-700 mb-3">{r.not_sold_yet.map((p) => `${p.name} (${p.code})`).join(", ") || "—"}</p>
      <p className="font-black text-sm mb-1">Vapes restantes ({r.units_left}) :</p>
      {r.people.map((p) => <p key={p.id} className="text-xs text-zinc-700">{p.name} : {p.models_left.filter((m) => m.left).map((m) => `${m.name} ×${m.left}`).join(", ") || "0"} · vendu {p.sold} · {$(p.revenue)}</p>)}
    </div>
  </div>
);

export const LotsPanel = () => {
  const [lots, setLots] = useState([]); const [f, setF] = useState({ name: "", amount: "", estimated_profit: "", control_date: "" }); const [rep, setRep] = useState(null);
  const load = () => axios.get(`${API}/ceo/lots`).then((r) => setLots(r.data.items || []));
  useEffect(() => { load(); }, []);
  const create = async () => { try { await axios.post(`${API}/ceo/lots`, { ...f, control_date: f.control_date ? new Date(f.control_date).toISOString() : null }); setF({ name: "", amount: "", estimated_profit: "", control_date: "" }); toast.success("Lot créé"); load(); } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); } };
  const assign = async (lot, u, action = "add") => { try { await axios.post(`${API}/ceo/lots/${lot.id}/assign`, { user_id: u.id, action }); load(); } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); } };
  const report = async (lot) => { const r = await axios.post(`${API}/ceo/lots/${lot.id}/report`); setRep(r.data); };
  const lastAuto = async (lot) => { const r = await axios.get(`${API}/ceo/lots/${lot.id}/reports`); if (!r.data.items.length) return toast.info("Pas encore de rapport mensuel"); setRep(r.data.items[0]); };
  return (
    <div className={card} data-testid="lots-panel">
      <p className="text-zinc-900 font-black text-lg mb-3 flex items-center gap-2"><Layers className="w-5 h-5 text-amber-600" />Lots d'investissement</p>
      <div className="flex gap-2 flex-wrap mb-4">
        <input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Nom du lot" className={`${inp} flex-1 min-w-[140px]`} data-testid="lot-name" />
        <input value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} type="number" placeholder="Montant investi $" className={`${inp} w-36`} data-testid="lot-amount" />
        <input value={f.estimated_profit} onChange={(e) => setF({ ...f, estimated_profit: e.target.value })} type="number" placeholder="Profit estimé $" className={`${inp} w-32`} data-testid="lot-estimate" />
        <input value={f.control_date} onChange={(e) => setF({ ...f, control_date: e.target.value })} type="date" className={inp} data-testid="lot-control-date" />
        <button onClick={create} className="bg-black text-amber-400 font-black text-sm px-4 rounded-lg" data-testid="lot-create">Créer le lot</button>
      </div>
      <div className="space-y-3">
        {lots.map((lot) => (
          <div key={lot.id} className="border border-zinc-200 rounded-xl p-3" data-testid={`lot-${lot.id}`}>
            <div className="flex items-center gap-2 flex-wrap mb-2">
              <p className="flex-1 text-zinc-900 font-black">{lot.name} <span className="text-zinc-500 text-xs font-normal">· {$(lot.amount)} · estimé {$(lot.estimated_profit)} · contrôle {lot.control_date ? new Date(lot.control_date).toLocaleDateString("fr-FR") : "—"}</span></p>
              <button onClick={() => report(lot)} className="text-xs font-bold bg-amber-400 text-black px-3 py-1.5 rounded-lg flex items-center gap-1" data-testid={`lot-report-${lot.id}`}><FileText className="w-3.5 h-3.5" />Rapport maintenant</button>
              <button onClick={() => lastAuto(lot)} className="text-xs font-bold bg-zinc-100 text-zinc-800 px-3 py-1.5 rounded-lg" data-testid={`lot-last-report-${lot.id}`}>Dernier rapport mensuel</button>
            </div>
            <div className="flex flex-wrap gap-2 mb-2">
              {lot.people.map((p) => <span key={p.id} className="bg-zinc-100 text-zinc-900 text-xs rounded-lg px-2 py-1 flex items-center gap-1.5" data-testid={`lot-person-${p.id}`}>{p.name} <span className="text-zinc-500">{p.code} · vendu {p.sold} · reste {p.remaining}</span><button onClick={() => assign(lot, p, "remove")} className="text-red-500"><X className="w-3 h-3" /></button></span>)}
              {!lot.people.length && <span className="text-zinc-500 text-xs">Aucune personne dans ce lot.</span>}
            </div>
            <UserSearch onPick={(u) => assign(lot, u)} testid={`lot-add-${lot.id}`} />
          </div>
        ))}
      </div>
      {rep && <LotReport r={rep} onClose={() => setRep(null)} />}
    </div>
  );
};

// "+ LOT" on a stocker card: shows the lots of origin and opens Finance > Investissement + Nouveau Lot
export const LotAssignButton = ({ user, onGo }) => (
  <span className="inline-flex items-center gap-1 flex-wrap" onClick={(e) => e.stopPropagation()}>
    {(user.stock_batches || []).map((l) => (
      <span key={l.batch_id} className="text-[10px] bg-blue-600 text-white px-2 py-0.5 rounded-full font-black" data-testid={`stocker-lot-${user.id}-${l.batch_id}`}>{l.name}</span>
    ))}
    <button onClick={(e) => { e.stopPropagation(); onGo(user); }} className="text-[10px] bg-amber-400 hover:bg-amber-300 text-black px-2 py-0.5 rounded-full font-black uppercase tracking-widest" data-testid={`lot-assign-btn-${user.id}`}>＋ Lot</button>
  </span>
);

// Banner on top of "Investissement + Nouveau Lot" when the CEO came from "+ LOT"
export const LotLinkBanner = ({ target, onCancel }) => target ? (
  <div className="bg-amber-400 text-black rounded-xl px-4 py-3 mb-3 flex items-center gap-3 flex-wrap" data-testid="lot-link-banner" data-no-contrast-guard>
    <p className="flex-1 text-sm font-black">Lier <span className="underline">{target.name}</span> à un lot : cliquez sur « Lier » sur le lot choisi ci-dessous.</p>
    <button onClick={onCancel} className="bg-black text-amber-400 text-xs font-black px-3 py-1.5 rounded-lg" data-testid="lot-link-cancel">Annuler</button>
  </div>
) : null;

// Linked people + one-click link button inside each lot card
export const BatchLinkBar = ({ batch, target, onDone }) => {
  const people = batch.assigned_users || [];
  const call = async (uid, action, name) => {
    try {
      await axios.post(`${API}/ceo/stock-batches/${batch.id}/link`, { user_id: uid, action });
      toast.success(action === "remove" ? `${name} retiré du lot ${batch.name}` : `${name} lié au lot ${batch.name}`);
      onDone(action);
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };
  const linked = target && people.some((p) => p.id === target.id);
  return (
    <div className="mt-2 pt-2 border-t border-zinc-700" data-testid={`batch-people-${batch.id}`}>
      <BatchProfit batchId={batch.id} refresh={people.length} />
      <p className="text-zinc-500 text-[10px] uppercase mb-1">Personnes liées ({people.length})</p>
      <div className="flex flex-wrap gap-1.5 items-center">
        {people.map((p) => (
          <span key={p.id || p.name} className="bg-zinc-900 text-white text-xs rounded-lg px-2 py-1 flex items-center gap-1.5" data-testid={`batch-person-${batch.id}-${p.id}`}>
            {p.name} <span className="text-zinc-400">{p.code}</span>
            {p.id && <button onClick={() => window.confirm(`Retirer ${p.name} du lot ${batch.name} ?`) && call(p.id, "remove", p.name)} className="text-red-400 hover:text-red-300" data-testid={`batch-unlink-${batch.id}-${p.id}`}><X className="w-3 h-3" /></button>}
          </span>
        ))}
        {!people.length && <span className="text-zinc-500 text-xs">Aucune personne liée.</span>}
        {target && !linked && (
          <button onClick={() => call(target.id, "add", target.name)} className="ml-auto bg-amber-400 hover:bg-amber-300 text-black text-xs font-black px-3 py-1.5 rounded-lg" data-testid={`batch-link-btn-${batch.id}`}>Lier {target.name}</button>
        )}
      </div>
    </div>
  );
};

// Real profit of a lot = sales - investment - bonus - commissions
const BatchProfit = ({ batchId, refresh }) => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/ceo/stock-batches/${batchId}/profit`).then((r) => setD(r.data)).catch(() => {}); }, [batchId, refresh]);
  if (!d) return null;
  const pos = d.profit >= 0;
  return (
    <div className="mb-2" data-testid={`batch-profit-${batchId}`}>
      <div className="flex justify-between text-[11px] mb-1">
        <span className="text-zinc-400">Vendu {d.units_sold} / {d.total_units} · reste {d.units_left}</span>
        <span className="text-amber-400 font-black" data-testid={`batch-profit-pct-${batchId}`}>{d.pct_sold}%</span>
      </div>
      <div className="h-2 bg-zinc-900 rounded-full overflow-hidden mb-2"><div className="h-full bg-amber-400 rounded-full transition-[width] duration-700" style={{ width: `${Math.min(100, d.pct_sold)}%` }} /></div>
      <div className="grid grid-cols-3 md:grid-cols-5 gap-1.5 text-center text-[11px]">
        {[["Ventes", d.revenue, "text-emerald-400"], ["Investi", -d.investment, "text-pink-400"], ["Bonus", -d.bonus, "text-amber-300"], ["Commissions", -d.commission, "text-blue-400"]].map(([k, v, c]) => (
          <div key={k} className="bg-zinc-900/70 rounded-lg p-1.5"><p className="text-zinc-500">{k}</p><p className={`font-black ${c}`}>{$(v)}</p></div>
        ))}
        <div className={`rounded-lg p-1.5 col-span-3 md:col-span-1 ${pos ? "bg-emerald-600" : "bg-red-600"}`}><p className="text-white/80">Profit réel</p><p className="font-black text-white" data-testid={`batch-profit-value-${batchId}`}>{$(d.profit)}</p></div>
      </div>
    </div>
  );
};

// CSV exports — one file per data type
const EXPORTS = [["stockers", "Stockers & NM"], ["sales", "Ventes"], ["withdrawals", "Retraits"], ["commissions", "Commissions"], ["cycles", "Cycles"]];
export const ExportCsvPanel = () => (
  <div className={card} data-testid="export-csv-panel">
    <p className="text-zinc-900 font-black text-lg mb-1 flex items-center gap-2"><Download className="w-5 h-5 text-amber-600" />Export CSV</p>
    <p className="text-zinc-500 text-xs mb-3">Un fichier par type de données — s'ouvre dans Excel ou Google Sheets.</p>
    <div className="flex flex-wrap gap-2">
      {EXPORTS.map(([k, label]) => (
        <button key={k} onClick={() => { window.location.href = `${API}/ceo/export/${k}`; }} className="bg-black hover:bg-zinc-800 text-amber-400 font-black text-sm px-4 py-2 rounded-lg flex items-center gap-1.5" data-testid={`export-csv-${k}`}><Download className="w-4 h-4" />{label}</button>
      ))}
    </div>
  </div>
);

// Read-only support history of one user (CEO)
export const SupportHistoryButton = ({ user }) => {
  const [convs, setConvs] = useState(null);
  const open = (e) => { e.stopPropagation(); axios.get(`${API}/ceo/support-conversations/user/${user.id}`).then((r) => setConvs(r.data.conversations || [])).catch(() => toast.error("Erreur")); };
  return (
    <span onClick={(e) => e.stopPropagation()}>
      <button onClick={open} className="text-[10px] bg-sky-500 hover:bg-sky-400 text-white px-2 py-0.5 rounded-full font-black uppercase tracking-widest inline-flex items-center gap-1" data-testid={`support-history-btn-${user.id}`}><MessageCircle className="w-3 h-3" />Support</button>
      {convs && createPortal(
        <div className="fixed inset-0 z-[140] bg-black/70 flex items-center justify-center p-4" onClick={() => setConvs(null)} data-testid="support-history-modal">
          <div className="bg-white rounded-2xl w-full max-w-xl max-h-[85vh] overflow-y-auto p-5 text-zinc-900" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-3">
              <div><p className="font-black text-lg">Support — {user.name}</p><p className="text-zinc-500 text-xs">Lecture seule · {convs.length} conversation(s)</p></div>
              <button onClick={() => setConvs(null)} className="p-2 rounded-lg bg-zinc-100 hover:bg-zinc-200" data-testid="support-history-close"><X className="w-4 h-4" /></button>
            </div>
            {!convs.length && <p className="text-zinc-500 text-sm" data-testid="support-history-empty">Aucune conversation avec le support.</p>}
            {convs.map((c) => (
              <div key={c.id} className="border border-zinc-200 rounded-xl p-3 mb-3" data-testid={`support-conv-${c.id}`}>
                <p className="text-[11px] text-zinc-500 mb-2">{fdate(c.started_at)} · {c.status === "closed" ? "Fermée" : "Ouverte"}{c.agent_name ? ` · Agent ${c.agent_name}` : ""}</p>
                <div className="space-y-1.5">
                  {(c.messages || []).filter((m) => m.content && m.content !== "[greet]").map((m, i) => (
                    <div key={i} className={`max-w-[85%] rounded-xl px-3 py-2 text-sm ${m.role === "user" ? "ml-auto bg-amber-100 text-zinc-900" : "bg-zinc-100 text-zinc-900"}`}>
                      <p className="whitespace-pre-wrap">{m.content}</p>
                      <p className="text-[10px] text-zinc-500 mt-0.5">{m.role === "user" ? user.name : c.agent_name || "Support"} · {fdate(m.at)}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>, document.body
      )}
    </span>
  );
};

// ===== 10. Live sales =====
export const LiveSales = () => {
  const [d, setD] = useState(null); const [month, setMonth] = useState("");
  useEffect(() => {
    const load = () => axios.get(`${API}/market/live`, { params: month ? { month } : {} }).then((r) => setD(r.data)).catch(() => {});
    load(); const t = setInterval(load, 5000); return () => clearInterval(t);
  }, [month]);
  if (!d) return null;
  const max = Math.max(1, ...d.per_day.map((x) => x.sold));
  return (
    <div className="bg-black rounded-2xl p-5 mb-4" data-testid="live-sales" data-no-contrast-guard>
      <div className="flex items-center gap-3 flex-wrap mb-4">
        <span className="w-2.5 h-2.5 bg-red-500 rounded-full animate-ping" />
        <p className="text-white font-black text-lg flex-1 flex items-center gap-2"><Activity className="w-5 h-5 text-amber-400" />Marché Vape Live</p>
        <select value={d.month} onChange={(e) => setMonth(e.target.value)} className="bg-zinc-900 border border-zinc-700 text-white rounded-lg px-3 py-1.5 text-sm" data-testid="live-month-select">
          {d.months.map((m) => <option key={m} value={m}>{new Date(m + "-15").toLocaleDateString("fr-FR", { month: "long", year: "numeric" })}</option>)}
        </select>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3">
        {[["/ seconde", d.avg_per_second], ["/ minute", d.avg_per_minute], ["/ heure", d.avg_per_hour], ["/ jour", d.avg_per_day]].map(([k, v]) => (
          <div key={k} className="bg-zinc-900 rounded-xl p-3"><p className="text-zinc-400 text-[10px] uppercase font-black">Vapes {k} (moy.)</p><p className="text-amber-400 font-black text-2xl" data-testid={`live-rate-${k.replace("/ ", "")}`}>{v}</p></div>))}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        {[["Dernière minute", d.last_minute], ["Dernière heure", d.last_hour], ["Aujourd'hui", d.today], ["Total du mois", d.total_sold]].map(([k, v]) => (
          <div key={k} className="bg-zinc-900/60 border border-zinc-800 rounded-xl p-3"><p className="text-zinc-400 text-[10px] uppercase font-black">{k}</p><p className="text-white font-black text-xl">{v}</p></div>))}
      </div>
      <div className="flex items-end gap-1 h-32 bg-zinc-950 rounded-xl p-2" data-testid="live-chart">
        {d.per_day.map((x) => (
          <div key={x.day} className="flex-1 flex flex-col items-center justify-end h-full group">
            <span className="text-[9px] text-amber-300 opacity-0 group-hover:opacity-100">{x.sold}</span>
            <div className="w-full bg-amber-400 rounded-t transition-[height] duration-500" style={{ height: `${(x.sold / max) * 100}%` }} title={`${x.day}: ${x.sold} vapes · $${x.revenue}`} />
            <span className="text-[8px] text-zinc-500 mt-0.5">{x.day.slice(8)}</span>
          </div>
        ))}
        {!d.per_day.length && <p className="text-zinc-500 text-sm m-auto">Aucune vente ce mois.</p>}
      </div>
      <p className="text-zinc-500 text-[11px] mt-2">Revenus du mois : ${d.total_revenue} · mise à jour toutes les 5 s</p>
    </div>
  );
};

// Stocker / NM: own live sales counter (refreshes every 10s)
export const MyLiveCounter = ({ userId }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!userId) return;
    const load = () => axios.get(`${API}/market/live/user/${userId}`).then((r) => setD(r.data)).catch(() => {});
    load(); const t = setInterval(load, 10000); return () => clearInterval(t);
  }, [userId]);
  if (!d) return null;
  return (
    <div className="bg-black rounded-2xl p-4 mb-5 flex items-center gap-4 flex-wrap" data-testid="my-live-counter" data-no-contrast-guard>
      <div className="flex items-center gap-2"><span className="w-2.5 h-2.5 bg-red-500 rounded-full animate-ping" /><p className="text-white font-black text-sm uppercase tracking-widest">Mes ventes en direct</p></div>
      {[["Aujourd'hui", d.today, "today"], ["Dernière heure", d.last_hour, "hour"], ["Dernière minute", d.last_minute, "minute"], ["Ce mois", d.month, "month"]].map(([k, v, id]) => (
        <div key={id} className="bg-zinc-900 rounded-xl px-4 py-2 min-w-[110px]"><p className="text-zinc-400 text-[10px] uppercase font-black">{k}</p><p className="text-amber-400 font-black text-2xl" data-testid={`my-live-${id}`}>{v}</p></div>
      ))}
      <p className="text-emerald-400 font-black text-sm ml-auto" data-testid="my-live-revenue">${Number(d.today_revenue || 0).toFixed(2)} aujourd'hui</p>
    </div>
  );
};
